export const COLUMN_TYPE_SLUGS = Object.freeze({
  TEXT: 'text', //simple cell text with div
  AVATAR_TEXT_USER: 'avatar-text-user', //Text with Avatar for now only first letter pass in Avatar later pass image if present
  AVATAR_TEXT_PATIENT: 'avatar-text-patient', //Text with Avatar for now only first letter pass in Avatar later pass image if present
  AVATAR_MULTIPLE_USER: 'avatar-multiple-user',
  FILTERS: 'filters',
  TEXT_COPY: 'text-copy', //Text that will have copy component with it
  STATUS: 'status', //Status Btn component will be used
  PILL: 'pill', //Status Btn component will be used
  ICON_PILL: 'icon-pill',
  ARRAY: 'array', //Array of strings that will be concatenated and displayed
  DATETIME: 'datetime', //Date format value must be formatted using moment / dayjs / custom util
  DATE: 'date', //Date format value must be formatted using moment / dayjs / custom util
  BOOLEAN: 'boolean', //convert boolean to text
  SHORT_TEXT_COPY: 'short-text-copy',
  TICKET_ASSIGNEE: 'ticket-assignee', //Change Assignee of the ticket
  JSON: 'json', //Will display json in key value form in tooltip
  TOGGLE: 'toggle', //toggle button
  MULTI_PILL: 'multi-pill',
  URL: 'url',
  PRODUCTS_ARRAY: 'products-array', //will display only the product variants,
  DEACTIVATE_USER_TOGGLE: 'deactivate-user-toggle',
  HOVER_TEXT_COPY: 'hover-text-copy',
});
